import React from "react";
import { useNavigate } from "react-router-dom";
import { colors, fonts } from "../theme";
import { View, Text, Card, Press, ScreenHeader, EmptyState } from "../ui";
import { Icon } from "../Icon";
import { useI18n } from "../i18n";
import { useAppState } from "../state";
import { lessonById, t } from "../content";

export default function Bookmarks() {
  const navigate = useNavigate();
  const { tr, lang } = useI18n();
  const { state } = useAppState();
  const items = state.bookmarks.map((id) => lessonById(id)).filter(Boolean);
  return (
    <View style={{ flex: 1, minHeight: "100vh", backgroundColor: colors.surfaceSecondary }}>
      <ScreenHeader title={tr("bookmarks")} onBack={() => navigate(-1)} />
      {items.length === 0 ? (
        <EmptyState icon="bookmark" title={tr("noBookmarks")} />
      ) : (
        <View style={{ padding: 20 }}>
          {items.map((l) => (
            <Press key={l.id} testID={`bookmark-${l.id}`} onClick={() => navigate(`/lesson/${l.id}`)}>
              <Card style={{ flexDirection: "row", alignItems: "center", gap: 12, marginBottom: 10 }}>
                <View style={{ width: 34, height: 34, borderRadius: 17, backgroundColor: colors.brandTertiary, alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                  <Icon name="bookmark" size={18} color={colors.brandPrimary} weight="fill" />
                </View>
                <View style={{ flex: 1, minWidth: 0 }}>
                  <Text numberOfLines={1} style={{ fontWeight: fonts.semibold, fontSize: 15, color: colors.onSurface }}>{t(l.title, lang)}</Text>
                  <Text style={{ fontWeight: fonts.regular, fontSize: 12, color: colors.muted, marginTop: 2 }}>{t(l.topic, lang)} · {l.minutes} {tr("min")}</Text>
                </View>
                <Icon name="caret-right" size={18} color={colors.muted} />
              </Card>
            </Press>
          ))}
        </View>
      )}
    </View>
  );
}
